
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Train against bots in 1v1 or 5v5',
    arenaCta: 'Play',
    title: 'Games',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Turn-based PvP for skins: gear up and outplay your rival',
    rushMidCta: 'Rush the mid',
    rouletteTitle: 'Russian Roulette',
    rouletteDescription: 'R8 cylinder, last one standing takes the bank',
    rouletteCta: 'Play',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Test your luck against other players',
    contractsTitle: 'Contracts',
    contractsDescription: 'Exchange items for better ones',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Upgrade items with a chance for rare skins',
    shopTitle: 'Shop',
    shopDescription: 'Buy items',
    comingSoon: 'Coming Soon',
    maintenanceBadge: 'Updating…',
    caseBattlesCta: 'Fight',
    contractsCta: 'Exchange',
    upgradeCta: 'Upgrade',
    shopCta: 'Open',
  },
  ru: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Тренируйся с ботами в 1×1 или 5×5',
    arenaCta: 'Играть',
    title: 'Игры',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Пошаговый PvP за скины: закупись и переиграй соперника',
    rushMidCta: 'Зарашить мид',
    rouletteTitle: 'Русская рулетка',
    rouletteDescription: 'Барабан R8, выживший забирает банк',
    rouletteCta: 'Играть',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Проверь удачу против других игроков',
    contractsTitle: 'Контракты',
    contractsDescription: 'Обменивай предметы на более ценные',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Улучшай предметы с шансом на редкие скины',
    shopTitle: 'Магазин',
    shopDescription: 'Покупай предметы',
    comingSoon: 'Скоро',
    maintenanceBadge: 'Обновление…',
    caseBattlesCta: 'В бой',
    contractsCta: 'Обменять',
    upgradeCta: 'Улучшить',
    shopCta: 'Открыть',
  },
  uz: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Botlarga qarshi 1×1 yoki 5×5 mashq qil',
    arenaCta: 'Oʻynash',
    title: 'Oʻyinlar',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: "Skinlar uchun navbatma-navbat PvP: qurollan va raqibingni ort",
    rushMidCta: 'Midni rush qilish',
    rouletteTitle: 'Rus ruletkasi',
    rouletteDescription: "R8 barabani, omon qolgan bankni oladi",
    rouletteCta: 'Oʻynash',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Boshqa oʻyinchilarga qarshi omadingizni sinab koʻring',
    contractsTitle: 'Kontraktlar',
    contractsDescription: 'Buyumlarni qimmatroqlariga almashtiring',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Buyumlarni kamyob skinlarga yaxshilash imkoniyati bilan',
    shopTitle: 'Doʻkon',
    shopDescription: 'Buyumlarni sotib oling',
    comingSoon: 'Tez kunda',
    maintenanceBadge: 'Yangilanmoqda…',
    caseBattlesCta: 'Jang',
    contractsCta: 'Almashtirish',
    upgradeCta: 'Yaxshilash',
    shopCta: 'Ochish',
  },
  fa: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'با ربات‌ها در ۱×۱ یا ۵×۵ تمرین کن',
    arenaCta: 'بازی کن',
    title: 'بازی‌ها',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'PvP نوبتی برای اسکین: تجهیز شو و حریفت را ببر',
    rushMidCta: 'بزن به مید',
    rouletteTitle: 'رولت روسی',
    rouletteDescription: 'خشاب R8، آخرین بازمانده بانک را می‌برد',
    rouletteCta: 'بازی کن',
    caseBattlesTitle: 'نبرد کیس',
    caseBattlesDescription: 'شانست را مقابل بازیکنان دیگر امتحان کن',
    contractsTitle: 'قراردادها',
    contractsDescription: 'آیتم‌ها را با آیتم بهتر عوض کن',
    upgradeTitle: 'ارتقا',
    upgradeDescription: 'آیتم‌ها را ارتقا بده و شانس اسکین کمیاب بگیر',
    shopTitle: 'فروشگاه',
    shopDescription: 'آیتم بخر',
    comingSoon: 'به‌زودی',
    maintenanceBadge: 'در حال به‌روزرسانی…',
    caseBattlesCta: 'بجنگ',
    contractsCta: 'عوض کن',
    upgradeCta: 'ارتقا بده',
    shopCta: 'باز کن',
  },
  pt: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Treina contra bots em 1×1 ou 5×5',
    arenaCta: 'Jogar',
    title: 'Jogos',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'PvP por turnos valendo skins: equipe-se e supere o rival',
    rushMidCta: 'Rushar o mid',
    rouletteTitle: 'Roleta russa',
    rouletteDescription: 'Tambor do R8, o último de pé leva o banco',
    rouletteCta: 'Jogar',
    caseBattlesTitle: 'Batalhas de caixas',
    caseBattlesDescription: 'Teste sua sorte contra outros jogadores',
    contractsTitle: 'Contratos',
    contractsDescription: 'Troque itens por outros mais valiosos',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Faça upgrade de itens com chance de skins raras',
    shopTitle: 'Loja',
    shopDescription: 'Compre itens',
    comingSoon: 'Em breve',
    maintenanceBadge: 'Atualizando…',
    caseBattlesCta: 'Lutar',
    contractsCta: 'Trocar',
    upgradeCta: 'Upgrade',
    shopCta: 'Abrir',
  },
  tr: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Botlara karşı 1×1 veya 5×5 antrenman yap',
    arenaCta: 'Oyna',
    title: 'Oyunlar',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Skin için sıra tabanlı PvP: kuşan ve rakibini alt et',
    rushMidCta: "Mid'e rush at",
    rouletteTitle: 'Rus ruleti',
    rouletteDescription: 'R8 tamburu, hayatta kalan bankayı alır',
    rouletteCta: 'Oyna',
    caseBattlesTitle: 'Kasa savaşları',
    caseBattlesDescription: 'Diğer oyunculara karşı şansını dene',
    contractsTitle: 'Kontratlar',
    contractsDescription: 'Eşyaları daha değerlileriyle takas et',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Nadir skin şansıyla eşyalarını upgrade et',
    shopTitle: 'Mağaza',
    shopDescription: 'Eşya satın al',
    comingSoon: 'Yakında',
    maintenanceBadge: 'Güncelleniyor…',
    caseBattlesCta: 'Savaş',
    contractsCta: 'Takas et',
    upgradeCta: 'Upgrade',
    shopCta: 'Aç',
  },
  uk: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Тренуйся з ботами в 1×1 або 5×5',
    arenaCta: 'Грати',
    title: 'Ігри',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Покроковий PvP за скіни: закупись і переграй суперника',
    rushMidCta: 'Рашити мід',
    rouletteTitle: 'Російська рулетка',
    rouletteDescription: 'Барабан R8, той, хто вижив, забирає банк',
    rouletteCta: 'Грати',
    caseBattlesTitle: 'Кейс-батли',
    caseBattlesDescription: 'Перевір удачу проти інших гравців',
    contractsTitle: 'Контракти',
    contractsDescription: 'Обмінюй предмети на цінніші',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Покращуй предмети з шансом на рідкісні скіни',
    shopTitle: 'Магазин',
    shopDescription: 'Купуй предмети',
    comingSoon: 'Скоро',
    maintenanceBadge: 'Оновлення…',
    caseBattlesCta: 'У бій',
    contractsCta: 'Обміняти',
    upgradeCta: 'Upgrade',
    shopCta: 'Відкрити',
  },
  de: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Trainiere gegen Bots in 1v1 oder 5v5',
    arenaCta: 'Spielen',
    title: 'Spiele',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Rundenbasiertes PvP um Skins: rüste dich aus und überlist deinen Gegner',
    rushMidCta: 'Mid rushen',
    rouletteTitle: 'Russisches Roulette',
    rouletteDescription: 'R8-Trommel, der Überlebende holt sich die Bank',
    rouletteCta: 'Spielen',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Teste dein Glück gegen andere Spieler',
    contractsTitle: 'Contracts',
    contractsDescription: 'Tausche Items gegen wertvollere',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Verbessere Items mit der Chance auf seltene Skins',
    shopTitle: 'Shop',
    shopDescription: 'Kaufe Items',
    comingSoon: 'Bald verfügbar',
    maintenanceBadge: 'Wird aktualisiert…',
    caseBattlesCta: 'Kämpfen',
    contractsCta: 'Tauschen',
    upgradeCta: 'Upgrade',
    shopCta: 'Öffnen',
  },
  es: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Entrena contra bots en 1v1 o 5v5',
    arenaCta: 'Jugar',
    title: 'Juegos',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'PvP por turnos por skins: equípate y supera a tu rival',
    rushMidCta: 'Rushear mid',
    rouletteTitle: 'Ruleta rusa',
    rouletteDescription: 'Tambor R8, el que sobrevive se lleva el bote',
    rouletteCta: 'Jugar',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Pon a prueba tu suerte contra otros jugadores',
    contractsTitle: 'Contratos',
    contractsDescription: 'Intercambia objetos por otros mejores',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Mejora objetos con opción a skins raros',
    shopTitle: 'Tienda',
    shopDescription: 'Compra objetos',
    comingSoon: 'Próximamente',
    maintenanceBadge: 'Actualizando…',
    caseBattlesCta: 'A combatir',
    contractsCta: 'Intercambiar',
    upgradeCta: 'Hacer upgrade',
    shopCta: 'Abrir',
  },
  pl: {
    arenaTitle: 'Rush Mid v2',
    arenaDescription: 'Trenuj z botami w 1v1 albo 5v5',
    arenaCta: 'Graj',
    title: 'Gry',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Turowe PvP o skiny: uzbrój się i przechytrz rywala',
    rushMidCta: 'Rushuj mida',
    rouletteTitle: 'Rosyjska ruletka',
    rouletteDescription: 'Bębenek R8, ocalały zgarnia pulę',
    rouletteCta: 'Graj',
    caseBattlesTitle: 'Case Battle',
    caseBattlesDescription: 'Sprawdź swoje szczęście przeciwko innym graczom',
    contractsTitle: 'Kontrakty',
    contractsDescription: 'Wymieniaj przedmioty na lepsze',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Ulepszaj przedmioty z szansą na rzadkie skiny',
    shopTitle: 'Sklep',
    shopDescription: 'Kupuj przedmioty',
    comingSoon: 'Wkrótce',
    maintenanceBadge: 'Aktualizacja…',
    caseBattlesCta: 'Do walki',
    contractsCta: 'Wymień',
    upgradeCta: 'Upgrade',
    shopCta: 'Otwórz',
  },
});
